module.exports = __webpack_public_path__ + "static/evenementiel-8b45cdf08f649f8e414a6578ae585c7d.jpg";